import { useMutation } from '@tanstack/react-query'
import { NoContent } from '@/common/types_and_interfaces.ts'
import { ApiCallResult } from '@/lib/tanstack-utils.types.ts'
import axios from 'axios'
import { parseRequestError } from '@/common/utilities.ts'

export type EducationDistributionPayload = {
  education_type_id: number
  base_amount: number
}[]

export type UpdateEducationParams = {
  programId: number
  purseId: number
}

const updateEducationTypeDistributions = async (
  params: UpdateEducationParams,
  payload: EducationDistributionPayload
): Promise<NoContent> => {
  const { programId, purseId } = params

  try {
    await axios.post(
      `/programs/${programId}/purses/${purseId}/settings/education_type_distributions`,
      { education_distributions: payload }
    )
    return null
  } catch (e) {
    throw parseRequestError(e)
  }
}

type RequestPayload = {
  params: UpdateEducationParams
  payload: EducationDistributionPayload
}
export const useUpdateEducationDistributions = (): ApiCallResult<
  NoContent,
  RequestPayload
> => {
  return useMutation({
    mutationFn: async ({ params, payload }: RequestPayload) => {
      return await updateEducationTypeDistributions(params, payload)
    },
  })
}
